import { Card, Col, Row, Typography } from 'antd';
import { FC, ReactNode } from 'react';
import { Shuffle, WrenchAdjustableCircle } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { CriticalCssIcon, HttpRobotsIcon, ReferralLinkIcon, SiteDomainIcon, SitemapIcon, TemplatesIcon, WebPageIcon } from '@/common/components';
import { AppRoutes } from '@/common/interfaces';

interface Props {
  siteId: string;
}

const cards: (props: Props) => { name: string; icon: ReactNode; to: string }[] = ({ siteId }) => [
  {
    name: 'Сторінки',
    icon: <WebPageIcon size={60} />,
    to: AppRoutes.Pages.replace(':siteId', siteId),
  },
  {
    name: 'Домени',
    icon: <SiteDomainIcon size={60} />,
    to: AppRoutes.SiteDomains.replace(':siteId', siteId),
  },
  {
    name: 'Шаблонізація',
    icon: <TemplatesIcon size={60} />,
    to: AppRoutes.SitesTemplates.replace(':siteId', siteId),
  },
  {
    name: 'Вийнятки для роботів',
    icon: <HttpRobotsIcon size={60} />,
    to: AppRoutes.Robots.replace(':siteId', siteId),
  },
  {
    name: 'Файли індексації Sitemap',
    icon: <SitemapIcon size={60} />,
    to: AppRoutes.Sitemap.replace(':siteId', siteId),
  },
  {
    name: 'Search Console',
    icon: <WrenchAdjustableCircle size={60} />,
    to: AppRoutes.SiteSearchConsole.replace(':siteId', siteId),
  },
  {
    name: 'Реферали',
    icon: <ReferralLinkIcon size={60} />,
    to: AppRoutes.Referrals.replace(':siteId', siteId),
  },
  {
    name: 'Редіректи',
    icon: <Shuffle size={60} />,
    to: AppRoutes.Redirects.replace(':siteId', siteId),
  },
  {
    name: 'Critical CSS',
    icon: <CriticalCssIcon size={60} />,
    to: AppRoutes.SitesCriticalCss.replace(':siteId', siteId),
  },
];

export const SitesOverviewCardsView: FC<Props> = (props) => {
  return (
    <Row gutter={[16, 16]} align="stretch">
      {cards(props).map((card) => (
        <Col key={card.name} span={6}>
          <Link to={card.to}>
            <Card
              hoverable
              title={
                <div style={{ opacity: 0.85, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{card.icon}</div>
              }
              size="small"
              style={{ height: '100%' }}
              styles={{
                header: { height: 'calc(100% - 48px)' },
                body: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 48 },
                title: { display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20 },
              }}
            >
              <Typography.Title ellipsis={{ rows: 1 }} level={5} style={{ margin: 0 }}>
                {card.name}
              </Typography.Title>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>
  );
};
